import React, {Component} from 'react';
import {BeatLoader} from 'react-spinners';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import {_addNotification, _addNotificationError} from "../../../../server/util";
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
import {HorizontalBar} from 'react-chartjs-2';
var _ = require('lodash');
class MostOrdered extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            selectedSchoolId:this.props.selectSchool,
            mealType:this.props.mealType, 
        }
    }
    render(){
        const {selectedDates}= this.props.data;
       const data={
            labels: Object.keys(this.props.data.data).map(key=>{
                return key
            }),
            datasets: [
              {
                data: Object.values(this.props.data.data).map(value=>{
                    return value
                }),
                label: 'Ordered count',
                backgroundColor: 'rgba(244, 126, 53, 1)',
                borderColor: 'rgba(244, 126, 53, 1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(244, 126, 53, 1)',
                hoverBorderColor: 'rgba(244, 126, 53, 1)', 
              }
            ]
          }
          const options={
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                        ticks: {
                         fontSize: 9,
                        min:0                
                    }
                       }],
                xAxes: [{
                        ticks: {
                         fontSize: 9,
                         min:0
                        }
                       }]
                     },
                     plugins: {
                       datalabels: {
                          display: true,
                          color: 'white',
                          font: { size: '10' },
                       }
                    }
        }
        return(<div>
         <NotificationSystem ref="notificationSystem"/> 
         <div className="col-md-4"> 
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>        
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                <span className="panel-title" style={{fontSize: '14px', fontWeight:'600'}}>Most Ordered Items</span>
                <div className="pull-right">
                <DateTimeRangePicker startDate={selectedDates.startDate} endDate={selectedDates.endDate}
                 applyCallback={(event,picker)=>{this.props.onChangeDateRange(picker.startDate,picker.endDate)}} isDateShow={false} />
                </div>
                <p style={{fontSize: '12px', fontWeight:'600'}}>{'Date Range: '+moment(selectedDates.startDate).format('DD-MMM-YYYY')+' to '+moment(selectedDates.endDate).format('DD-MMM-YYYY')}</p> 
            </div>
            <div className="panel-body" style={{padding:'0px'}}>        
            <HorizontalBar data={data} options={options} />
            </div>
            </div>
        </div>
        </div>)
    }
}
export default MostOrdered


// WEBPACK FOOTER //
// ./src/components/Caterer/Home/dashboard/mostOrdered.jsx